import React from "react";
import { CardAngularGradientWrapper, FooterImg } from "./styles";
import { Ptag } from "components/core";

function CardAngularGradient({ title, bgImg, children }) {
  return (
    <CardAngularGradientWrapper>
      <Ptag color="#4A4A4A99" fontSize="18px" marginBottom="14px">
        {title}
      </Ptag>
      {children}
      <FooterImg src={bgImg} />
    </CardAngularGradientWrapper>
  );
}

export default CardAngularGradient;
